<template>
  <section>
    <div class="overflow-hidden relative bg-black font-open-sans">
      <nuxt-img
          class="block object-cover absolute inset-0 w-full h-full"
          width="2269"
          height="1513"
          loading="lazy"
          format="webp"
          alt="background"
          :src="backgroundImageSrc"
      />

      <div class="flex relative flex-wrap items-center px-5 py-10 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 md:py-16 xl:py-24">
        <div class="py-11 w-full text-center bg-white lg:w-1/2">
          <h2 class="text-3xl font-extrabold md:text-4xl xl:text-6xl font-ww-medium" v-html="mainHeading1"></h2>
          <p class="py-7 mx-auto max-w-lg text-base text-gray-700 md:text-lg lg:text-2xl" v-html="paragraph1"></p>

          <div class="flex flex-wrap gap-y-9 justify-center py-9">
            <!-- Image 1 -->
            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text1"
                  :src="imageSrc1"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text1 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text2"
                  :src="imageSrc2"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text2 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text3"
                  :src="imageSrc3"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text3 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text4"
                  :src="imageSrc4"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text4 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text5"
                  :src="imageSrc5"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text5 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text6"
                  :src="imageSrc6"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text6 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text7"
                  :src="imageSrc7"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text7 }}</h6>
            </div>

            <div class="px-3.5 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/3 xl:w-1/4">
              <nuxt-img
                  class="block m-auto w-auto"
                  width="93"
                  height="93"
                  loading="lazy"
                  format="webp"
                  :alt="text8"
                  :src="imageSrc8"
              />
              <h6 class="pt-3.5 text-base font-extrabold tracking-wider uppercase">{{ text8 }}</h6>
            </div>

            <!-- Additional Images -->
            <!-- ... -->

          </div>
        </div>

        <div class="px-5 py-11 w-full text-center text-white lg:w-1/2">
          <h2 class="text-3xl font-extrabold md:text-4xl xl:text-6xl font-ww-medium" v-html="mainHeading2"></h2>
          <p class="py-7 mx-auto max-w-lg text-base md:text-lg lg:text-2xl" v-html="paragraph2"></p>
          <p class="pt-7 pb-3 mx-auto max-w-lg text-base md:text-lg lg:text-2xl" v-html="supportText"></p>
          <nuxt-img
              class="mx-auto w-full mix-blend-lighten"
              width="290"
              height="77"
              loading="lazy"
              format="webp"
              alt="Rainforest"
              :src="supporterImageSrc"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  mainHeading1: {
    type: String,
    default: 'Coffee that Cares<br> About You'
  },
  paragraph1: {
    type: String,
    default: 'Lifeboost Coffee meets the highest standards for quality without compromise:'
  },
  mainHeading2: {
    type: String,
    default: 'Coffee that Cares<br> About the Environment'
  },
  paragraph2: {
    type: String,
    default: 'We believe in giving back to the beautiful world we all live in and that gives us the opportunity to create Lifeboost Coffee. A portion of every dollar received goes toward protecting the environment.'
  },
  supportText: {
    type: String,
    default: 'Proud supporter of:'
  },
  backgroundImageSrc: {
    type: String,
    default: '/assets/images/coffee-bg.png'
  },
  imageSrc1: {
    type: String,
    default: '/assets/images/bm-icon-1.png'
  },
  text1: {
    type: String,
    default: 'ORGANIC'
  },
  imageSrc2: {
    type: String,
    default: '/assets/images/bm-icon-2.png'
  },
  text2: {
    type: String,
    default: 'SHADE GROWN'
  },
  imageSrc3: {
    type: String,
    default: '/assets/images/bm-icon-3.png'
  },
  text3: {
    type: String,
    default: 'SINGLE ORIGIN'
  },
  imageSrc4: {
    type: String,
    default: '/assets/images/bm-icon-4.png'
  },
  text4: {
    type: String,
    default: 'LOW ACID'
  },
  imageSrc5: {
    type: String,
    default: '/assets/images/bm-icon-5.png'
  },
  text5: {
    type: String,
    default: 'SUN DRIED'
  },
  imageSrc6: {
    type: String,
    default: '/assets/images/bm-icon-6.png'
  },
  text6: {
    type: String,
    default: 'PESTICIDE FREE'
  },
  imageSrc7: {
    type: String,
    default: '/assets/images/bm-icon-7.png'
  },
  text7: {
    type: String,
    default: 'NO GMO’S'
  },
  imageSrc8: {
    type: String,
    default: '/assets/images/bm-icon-8.png'
  },
  text8: {
    type: String,
    default: 'NO TOXINS'
  },
  supporterImageSrc: {
    type: String,
    default: '/assets/images/rft.png'
  }
});

defineBuilderComponent({
    friendlyName: "Content Image Left3",
    inputs: [
        {
            name: "mainHeading1",
            type: "string",
            defaultValue: "Coffee that Cares<br> About You"
        },
        {
            name: "paragraph1",
            type: "string",
            defaultValue: "Lifeboost Coffee meets the highest standards for quality without compromise:"
        },
        {
            name: "mainHeading2",
            type: "string",
            defaultValue: "Coffee that Cares<br> About the Environment"
        },
        {
            name: "paragraph2",
            type: "string",
            defaultValue: "We believe in giving back to the beautiful world we all live in and that gives us the opportunity to create Lifeboost Coffee. A portion of every dollar received goes toward protecting the environment."
        },
        {
            name: "supportText",
            type: "string",
            defaultValue: "Proud supporter of:"
        },
        {
            name: "backgroundImageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/coffee-bg.png"
        },
        {
            name: "imageSrc1",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-1.png"
        },
        {
            name: "text1",
            type: "string",
            defaultValue: "ORGANIC"
        },
        {
            name: "imageSrc2",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-2.png"
        },
        {
            name: "text2",
            type: "string",
            defaultValue: "SHADE GROWN"
        },
        {
            name: "imageSrc3",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-3.png"
        },
        {
            name: "text3",
            type: "string",
            defaultValue: "SINGLE ORIGIN"
        },
        {
            name: "imageSrc4",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-4.png"
        },
        {
            name: "text4",
            type: "string",
            defaultValue: "LOW ACID"
        },
        {
            name: "imageSrc5",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-5.png"
        },
        {
            name: "text5",
            type: "string",
            defaultValue: "SUN DRIED"
        },
        {
            name: "imageSrc6",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-6.png"
        },
        {
            name: "text6",
            type: "string",
            defaultValue: "PESTICIDE FREE"
        },
        {
            name: "imageSrc7",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-7.png"
        },
        {
            name: "text7",
            type: "string",
            defaultValue: "NO GMO’S"
        },
        {
            name: "imageSrc8",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bm-icon-8.png"
        },
        {
            name: "text8",
            type: "string",
            defaultValue: "NO TOXINS"
        },
        {
            name: "supporterImageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/rft.png"
        }
    ]
});
</script>